/* global google */
/* global jQuery */
/* global require */
angular
  .module('setting')
  .component('setting', {
    template: require('./setting.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'uiGmapGoogleMapApi', 'CenterInfo',
      function OrdersSubscriptionController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        const APIURL = envService.read('apiUrl');
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'setting';
        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        $resource(`${APIURL}/admin/setting`).get({}).$promise
          .then((data) => {
            this.serviceSetting = data;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.isLevel2Auth = AuthService.isLevel2Authenticated();
        this.getTitle = () => {
          if (this.targetType === 'SERVICE_SHUTDOWN') {
            return '서비스 가능여부';
          } else if (this.targetType === 'WASH_OUTSIDE') {
            return '실외세차 가능여부';
          } else if (this.targetType === 'USER_CAN_REFUND_SUBSCRIPTION') {
            return '유저가 앱에서 정기세차 주문 환불 가능여부';
          } else if (this.targetType === 'NO_WASH_OUTSIDE_REASON_TITLE') {
            return '실외세차 불가 사유 제목';
          } else if (this.targetType === 'NO_WASH_OUTSIDE_REASON_MSG') {
            return '실외세차 불가 사유';
          } else if (this.targetType === 'NO_WASH_OUTSIDE_REASON_TITLE_EN') {
            return '실외세차 불가 사유 제목 (영문)';
          } else if (this.targetType === 'NO_WASH_OUTSIDE_REASON_MSG_EN') {
            return '실외세차 불가 사유 (영문)';
          }
          return '';
        };
        this.view = (type) => {
          if (type === 'SERVICE_SHUTDOWN' && !this.isLevel2Auth) {
            return;
          }
          this.targetType = type;
          this.serviceSettingEdit = {};
          if (type === 'NO_WASH_OUTSIDE_REASON_TITLE') {
            this.serviceSettingEdit = { NO_WASH_OUTSIDE_REASON_TITLE: this.serviceSetting.NO_WASH_OUTSIDE_REASON_TITLE };
          } else if (type === 'NO_WASH_OUTSIDE_REASON_MSG') {
            this.serviceSettingEdit = { NO_WASH_OUTSIDE_REASON_MSG: this.serviceSetting.NO_WASH_OUTSIDE_REASON_MSG };
          } else if (type === 'NO_WASH_OUTSIDE_REASON_TITLE_EN') {
            this.serviceSettingEdit = { NO_WASH_OUTSIDE_REASON_TITLE_EN: this.serviceSetting.NO_WASH_OUTSIDE_REASON_TITLE_EN };
          } else if (type === 'NO_WASH_OUTSIDE_REASON_MSG_EN') {
            this.serviceSettingEdit = { NO_WASH_OUTSIDE_REASON_MSG_EN: this.serviceSetting.NO_WASH_OUTSIDE_REASON_MSG_EN };
          }
          jQuery('#modal-view').modal('show');
        };
        this.modifySubmit = () => {
          let strUrl = `${APIURL}/admin/setting`;
          switch (this.targetType) {
            case 'SERVICE_SHUTDOWN':
              strUrl += '/shutdown';
              break;
            case 'WASH_OUTSIDE':
            case 'NO_WASH_OUTSIDE_REASON_TITLE':
            case 'NO_WASH_OUTSIDE_REASON_MSG':
            case 'NO_WASH_OUTSIDE_REASON_TITLE_EN':
            case 'NO_WASH_OUTSIDE_REASON_MSG_EN':
              strUrl += '/washoutside';
              break;
            case 'USER_CAN_REFUND_SUBSCRIPTION':
              strUrl += '/user/refund/subscription';
              break;
            default:
              break;
          }
          $resource(strUrl).save(this.serviceSettingEdit).$promise
            .then((data) => {
              this.serviceSetting = data;
              jQuery('#modal-view').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });


// WEBPACK FOOTER //
// ./src/app/service/setting/setting.component.js